var map = {
	"./main/admin-settings/admin-settings.module": [
		"./src/app/main/admin-settings/admin-settings.module.ts",
		"common",
		"main-admin-settings-admin-settings-module"
	],
	"./main/approval-rules/approval-rules.module": [
		"./src/app/main/approval-rules/approval-rules.module.ts",
		"main-approval-rules-approval-rules-module"
	],
	"./main/asset/asset.module": [
		"./src/app/main/asset/asset.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"main-asset-asset-module~main-bank-bank-module~main-target-v4-target-v4-module",
		"common",
		"main-asset-asset-module"
	],
	"./main/attendance/attendance.module": [
		"./src/app/main/attendance/attendance.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-attendance-attendance-module"
	],
	"./main/authentication/auth.module": [
		"./src/app/main/authentication/auth.module.ts",
		"common",
		"main-authentication-auth-module"
	],
	"./main/bank/bank.module": [
		"./src/app/main/bank/bank.module.ts",
		"main-asset-asset-module~main-bank-bank-module~main-target-v4-target-v4-module",
		"common",
		"main-bank-bank-module"
	],
	"./main/bill-pending-organization/bill-pending-organization.module": [
		"./src/app/main/bill-pending-organization/bill-pending-organization.module.ts",
		"common",
		"main-bill-pending-organization-bill-pending-organization-module"
	],
	"./main/central-stock/central-stock.module": [
		"./src/app/main/central-stock/central-stock.module.ts",
		"main-central-stock-central-stock-module"
	],
	"./main/code-generator-rule/code-generator-rule.module": [
		"./src/app/main/code-generator-rule/code-generator-rule.module.ts",
		"main-code-generator-rule-code-generator-rule-module"
	],
	"./main/credit/credit.module": [
		"./src/app/main/credit/credit.module.ts",
		"common",
		"main-credit-credit-module"
	],
	"./main/customer-account-transactions/customer-account-transaction.module": [
		"./src/app/main/customer-account-transactions/customer-account-transaction.module.ts",
		"main-customer-account-transactions-customer-account-transaction-module"
	],
	"./main/customer-campaign/customer-campaign.module": [
		"./src/app/main/customer-campaign/customer-campaign.module.ts",
		"common",
		"main-customer-campaign-customer-campaign-module"
	],
	"./main/customer-delivery-challan/customer-delivery-challan.module": [
		"./src/app/main/customer-delivery-challan/customer-delivery-challan.module.ts",
		"common",
		"main-customer-delivery-challan-customer-delivery-challan-module"
	],
	"./main/customer-invoice/customer-invoice.module": [
		"./src/app/main/customer-invoice/customer-invoice.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-customer-invoice-customer-invoice-module"
	],
	"./main/customer-payment/customer-payment.module": [
		"./src/app/main/customer-payment/customer-payment.module.ts",
		"common",
		"main-customer-payment-customer-payment-module"
	],
	"./main/customer-return-challan/customer-return-challan.module": [
		"./src/app/main/customer-return-challan/customer-return-challan.module.ts",
		"common",
		"main-customer-return-challan-customer-return-challan-module"
	],
	"./main/customer-return/customer-return.module": [
		"./src/app/main/customer-return/customer-return.module.ts",
		"common",
		"main-customer-return-customer-return-module"
	],
	"./main/customer-type/customer-type.module": [
		"./src/app/main/customer-type/customer-type.module.ts",
		"main-customer-type-customer-type-module"
	],
	"./main/customer/customer.module": [
		"./src/app/main/customer/customer.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-customer-customer-module"
	],
	"./main/customerReturnReason/customerReturnReason.module": [
		"./src/app/main/customerReturnReason/customerReturnReason.module.ts",
		"main-customerReturnReason-customerReturnReason-module"
	],
	"./main/da-rule/da-rule.module": [
		"./src/app/main/da-rule/da-rule.module.ts",
		"common",
		"main-da-rule-da-rule-module"
	],
	"./main/daily-shift/daily-shift.module": [
		"./src/app/main/daily-shift/daily-shift.module.ts",
		"common",
		"main-daily-shift-daily-shift-module"
	],
	"./main/daily-ta-da-claim/daily-ta-da-claim.module": [
		"./src/app/main/daily-ta-da-claim/daily-ta-da-claim.module.ts",
		"common",
		"main-daily-ta-da-claim-daily-ta-da-claim-module"
	],
	"./main/daily-ta-da/daily-ta-da.module": [
		"./src/app/main/daily-ta-da/daily-ta-da.module.ts",
		"main-daily-ta-da-daily-ta-da-module"
	],
	"./main/dashboard/dashboard.module": [
		"./src/app/main/dashboard/dashboard.module.ts",
		"main-dashboard-dashboard-module"
	],
	"./main/dealer-account-transactions/dealer-account-transactions.module": [
		"./src/app/main/dealer-account-transactions/dealer-account-transactions.module.ts",
		"main-dealer-account-transactions-dealer-account-transactions-module"
	],
	"./main/dealer-campaign/dealer-campaign.module": [
		"./src/app/main/dealer-campaign/dealer-campaign.module.ts",
		"common",
		"main-dealer-campaign-dealer-campaign-module"
	],
	"./main/dealer-payment/dealer-payment.module": [
		"./src/app/main/dealer-payment/dealer-payment.module.ts",
		"common",
		"main-dealer-payment-dealer-payment-module"
	],
	"./main/dealer-stock/dealer-stock.module": [
		"./src/app/main/dealer-stock/dealer-stock.module.ts",
		"common",
		"main-dealer-stock-dealer-stock-module"
	],
	"./main/dealer-type/dealer-type.module": [
		"./src/app/main/dealer-type/dealer-type.module.ts",
		"main-dealer-type-dealer-type-module"
	],
	"./main/dealer/dealer.module": [
		"./src/app/main/dealer/dealer.module.ts",
		"common",
		"main-dealer-dealer-module"
	],
	"./main/distributor-account-transactions/distributor-account-transaction.module": [
		"./src/app/main/distributor-account-transactions/distributor-account-transaction.module.ts",
		"main-distributor-account-transactions-distributor-account-transaction-module"
	],
	"./main/distributor-bank-account/distributor-bank-account.module": [
		"./src/app/main/distributor-bank-account/distributor-bank-account.module.ts",
		"common",
		"main-distributor-bank-account-distributor-bank-account-module"
	],
	"./main/distributor-campaign/distributor-campaign.module": [
		"./src/app/main/distributor-campaign/distributor-campaign.module.ts",
		"common",
		"main-distributor-campaign-distributor-campaign-module"
	],
	"./main/distributor-centre/distributor-centre.module": [
		"./src/app/main/distributor-centre/distributor-centre.module.ts",
		"main-distributor-centre-distributor-centre-module"
	],
	"./main/distributor-dealer-delivery/distributor-dealer-delivery.module": [
		"./src/app/main/distributor-dealer-delivery/distributor-dealer-delivery.module.ts",
		"common",
		"main-distributor-dealer-delivery-distributor-dealer-delivery-module"
	],
	"./main/distributor-dealer-invoice/distributor-dealer-invoice.module": [
		"./src/app/main/distributor-dealer-invoice/distributor-dealer-invoice.module.ts",
		"common",
		"main-distributor-dealer-invoice-distributor-dealer-invoice-module"
	],
	"./main/distributor-dealer-order/distributor-dealer-order.module": [
		"./src/app/main/distributor-dealer-order/distributor-dealer-order.module.ts",
		"common",
		"main-distributor-dealer-order-distributor-dealer-order-module"
	],
	"./main/distributor-delivery-challan/distributor-delivery-challan.module": [
		"./src/app/main/distributor-delivery-challan/distributor-delivery-challan.module.ts",
		"common",
		"main-distributor-delivery-challan-distributor-delivery-challan-module"
	],
	"./main/distributor-invoice/distributor-invoice.module": [
		"./src/app/main/distributor-invoice/distributor-invoice.module.ts",
		"common",
		"main-distributor-invoice-distributor-invoice-module"
	],
	"./main/distributor-payment/distributor-payment.module": [
		"./src/app/main/distributor-payment/distributor-payment.module.ts",
		"main-distributor-payment-distributor-payment-module"
	],
	"./main/distributor-return-challan/distributor-return-challan.module": [
		"./src/app/main/distributor-return-challan/distributor-return-challan.module.ts",
		"common",
		"main-distributor-return-challan-distributor-return-challan-module"
	],
	"./main/distributor-return-stock/distributor-return-stock.module": [
		"./src/app/main/distributor-return-stock/distributor-return-stock.module.ts",
		"main-distributor-return-stock-distributor-return-stock-module"
	],
	"./main/distributor-return/distributor-return.module": [
		"./src/app/main/distributor-return/distributor-return.module.ts",
		"common",
		"main-distributor-return-distributor-return-module"
	],
	"./main/distributor-stock/distributor-stock.module": [
		"./src/app/main/distributor-stock/distributor-stock.module.ts",
		"common",
		"main-distributor-stock-distributor-stock-module"
	],
	"./main/distributor-type/distributor-type.module": [
		"./src/app/main/distributor-type/distributor-type.module.ts",
		"main-distributor-type-distributor-type-module"
	],
	"./main/distributor-user/distributor-user.module": [
		"./src/app/main/distributor-user/distributor-user.module.ts",
		"common",
		"main-distributor-user-distributor-user-module"
	],
	"./main/distributor/distributor.module": [
		"./src/app/main/distributor/distributor.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"common",
		"main-distributor-distributor-module"
	],
	"./main/distributorReturnReason/distributorReturnReason.module": [
		"./src/app/main/distributorReturnReason/distributorReturnReason.module.ts",
		"main-distributorReturnReason-distributorReturnReason-module"
	],
	"./main/dsr-user/dsr-user.module": [
		"./src/app/main/dsr-user/dsr-user.module.ts",
		"common",
		"main-dsr-user-dsr-user-module"
	],
	"./main/email-notification/email-notification.module": [
		"./src/app/main/email-notification/email-notification.module.ts",
		"main-email-notification-email-notification-module"
	],
	"./main/engagement-report/engagement-report.module": [
		"./src/app/main/engagement-report/engagement-report.module.ts",
		"common",
		"main-engagement-report-engagement-report-module"
	],
	"./main/engagement/engagement.module": [
		"./src/app/main/engagement/engagement.module.ts",
		"common",
		"main-engagement-engagement-module"
	],
	"./main/expense-claim-approval-rules/expense-claim-approval-rules.module": [
		"./src/app/main/expense-claim-approval-rules/expense-claim-approval-rules.module.ts",
		"common",
		"main-expense-claim-approval-rules-expense-claim-approval-rules-module"
	],
	"./main/expense-claim/expense-claim.module": [
		"./src/app/main/expense-claim/expense-claim.module.ts",
		"common",
		"main-expense-claim-expense-claim-module"
	],
	"./main/expense-purpose/expense-purpose.module": [
		"./src/app/main/expense-purpose/expense-purpose.module.ts",
		"main-expense-purpose-expense-purpose-module"
	],
	"./main/expense-sub-type/expense-sub-type.module": [
		"./src/app/main/expense-sub-type/expense-sub-type.module.ts",
		"main-expense-sub-type-expense-sub-type-module"
	],
	"./main/expense-type/expense-type.module": [
		"./src/app/main/expense-type/expense-type.module.ts",
		"main-expense-type-expense-type-module"
	],
	"./main/fmcg-customer-invoice/fmcg-customer-invoice.module": [
		"./src/app/main/fmcg-customer-invoice/fmcg-customer-invoice.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-fmcg-customer-invoice-fmcg-customer-invoice-module"
	],
	"./main/general-return/general-return.module": [
		"./src/app/main/general-return/general-return.module.ts",
		"common",
		"main-general-return-general-return-module"
	],
	"./main/geo-hierarchy/geo-hierarchy.module": [
		"./src/app/main/geo-hierarchy/geo-hierarchy.module.ts",
		"common",
		"main-geo-hierarchy-geo-hierarchy-module"
	],
	"./main/holiday/holiday.module": [
		"./src/app/main/holiday/holiday.module.ts",
		"main-holiday-holiday-module"
	],
	"./main/ims/ims.module": [
		"./src/app/main/ims/ims.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-ims-ims-module"
	],
	"./main/income/income.module": [
		"./src/app/main/income/income.module.ts",
		"main-income-income-module"
	],
	"./main/leave-account/leave-account.module": [
		"./src/app/main/leave-account/leave-account.module.ts",
		"common",
		"main-leave-account-leave-account-module"
	],
	"./main/leave-allocation/leave-allocation.module": [
		"./src/app/main/leave-allocation/leave-allocation.module.ts",
		"common",
		"main-leave-allocation-leave-allocation-module"
	],
	"./main/leave-type/leave-type.module": [
		"./src/app/main/leave-type/leave-type.module.ts",
		"common",
		"main-leave-type-leave-type-module"
	],
	"./main/level/level.module": [
		"./src/app/main/level/level.module.ts",
		"main-level-level-module"
	],
	"./main/linnex-tertiary-sales/linnex-tertiary-sales.module": [
		"./src/app/main/linnex-tertiary-sales/linnex-tertiary-sales.module.ts",
		"main-linnex-tertiary-sales-linnex-tertiary-sales-module"
	],
	"./main/location/location.module": [
		"./src/app/main/location/location.module.ts"
	],
	"./main/lovello-fridge/lovello-fridge.module": [
		"./src/app/main/lovello-fridge/lovello-fridge.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-lovello-fridge-lovello-fridge-module"
	],
	"./main/market-level/market-level.module": [
		"./src/app/main/market-level/market-level.module.ts",
		"common",
		"main-market-level-market-level-module"
	],
	"./main/market/market.module": [
		"./src/app/main/market/market.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-market-market-module"
	],
	"./main/noc/noc.module": [
		"./src/app/main/noc/noc.module.ts",
		"main-noc-noc-module"
	],
	"./main/notice-board-for-others/notice-board-for-others.module": [
		"./src/app/main/notice-board-for-others/notice-board-for-others.module.ts",
		"common",
		"main-notice-board-for-others-notice-board-for-others-module"
	],
	"./main/notice-board/notice-board.module": [
		"./src/app/main/notice-board/notice-board.module.ts",
		"common",
		"main-notice-board-notice-board-module"
	],
	"./main/notification-rule/notification-rule.module": [
		"./src/app/main/notification-rule/notification-rule.module.ts",
		"main-notification-rule-notification-rule-module"
	],
	"./main/order-volume-summary/order-volume-summary.module": [
		"./src/app/main/order-volume-summary/order-volume-summary.module.ts",
		"common",
		"main-order-volume-summary-order-volume-summary-module"
	],
	"./main/orderReport/orderReport.module": [
		"./src/app/main/orderReport/orderReport.module.ts",
		"common",
		"main-orderReport-orderReport-module"
	],
	"./main/organization-bank-account/organization-bank-account.module": [
		"./src/app/main/organization-bank-account/organization-bank-account.module.ts",
		"common",
		"main-organization-bank-account-organization-bank-account-module"
	],
	"./main/organization/organization.module": [
		"./src/app/main/organization/organization.module.ts",
		"common",
		"main-organization-organization-module"
	],
	"./main/payment-category/payment-category.module": [
		"./src/app/main/payment-category/payment-category.module.ts",
		"main-payment-category-payment-category-module"
	],
	"./main/payment-method/payment-method.module": [
		"./src/app/main/payment-method/payment-method.module.ts",
		"main-payment-method-payment-method-module"
	],
	"./main/payment-purpose/payment-purpose.module": [
		"./src/app/main/payment-purpose/payment-purpose.module.ts",
		"main-payment-purpose-payment-purpose-module"
	],
	"./main/pjp/pjp.module": [
		"./src/app/main/pjp/pjp.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"main-pjp-pjp-module~main-route-plan-route-plan-module~main-user-wise-expense-summary-user-wise-expen~936cc80d",
		"common",
		"main-pjp-pjp-module"
	],
	"./main/poi/poi.module": [
		"./src/app/main/poi/poi.module.ts",
		"common",
		"main-poi-poi-module"
	],
	"./main/primary-order/primary-order.module": [
		"./src/app/main/primary-order/primary-order.module.ts",
		"common",
		"main-primary-order-primary-order-module"
	],
	"./main/product-Serial-Info/product-serial-info.module": [
		"./src/app/main/product-Serial-Info/product-serial-info.module.ts",
		"main-product-Serial-Info-product-serial-info-module"
	],
	"./main/product-brand/product-brand.module": [
		"./src/app/main/product-brand/product-brand.module.ts",
		"common",
		"main-product-brand-product-brand-module"
	],
	"./main/product-campaign/product-campaign.module": [
		"./src/app/main/product-campaign/product-campaign.module.ts",
		"main-product-campaign-product-campaign-module"
	],
	"./main/product-group/product-group.module": [
		"./src/app/main/product-group/product-group.module.ts",
		"common",
		"main-product-group-product-group-module"
	],
	"./main/product-line/product-line.module": [
		"./src/app/main/product-line/product-line.module.ts",
		"common",
		"main-product-line-product-line-module"
	],
	"./main/product-type/product-type.module": [
		"./src/app/main/product-type/product-type.module.ts",
		"common",
		"main-product-type-product-type-module"
	],
	"./main/product/product.module": [
		"./src/app/main/product/product.module.ts",
		"common",
		"main-product-product-module"
	],
	"./main/project-report/project-report.module": [
		"./src/app/main/project-report/project-report.module.ts",
		"common",
		"main-project-report-project-report-module"
	],
	"./main/project/project.module": [
		"./src/app/main/project/project.module.ts",
		"common",
		"main-project-project-module"
	],
	"./main/report-attendance/report-attendance.module": [
		"./src/app/main/report-attendance/report-attendance.module.ts",
		"common",
		"main-report-attendance-report-attendance-module"
	],
	"./main/report-customer-invoice-product/report-customer-invoice-product.module": [
		"./src/app/main/report-customer-invoice-product/report-customer-invoice-product.module.ts",
		"main-report-customer-invoice-product-report-customer-invoice-product-module"
	],
	"./main/report-dealer/report-dealer.module": [
		"./src/app/main/report-dealer/report-dealer.module.ts",
		"main-report-dealer-report-dealer-module"
	],
	"./main/report-distributor/report-distributor.module": [
		"./src/app/main/report-distributor/report-distributor.module.ts",
		"common",
		"main-report-distributor-report-distributor-module"
	],
	"./main/report-expense-claim/report-expense-claim.module": [
		"./src/app/main/report-expense-claim/report-expense-claim.module.ts",
		"main-report-expense-claim-report-expense-claim-module"
	],
	"./main/report-ims/report-ims.module": [
		"./src/app/main/report-ims/report-ims.module.ts",
		"common",
		"main-report-ims-report-ims-module"
	],
	"./main/report-kpi/report-kpi.module": [
		"./src/app/main/report-kpi/report-kpi.module.ts",
		"common",
		"main-report-kpi-report-kpi-module"
	],
	"./main/report-leave/report-leave.module": [
		"./src/app/main/report-leave/report-leave.module.ts",
		"main-report-leave-report-leave-module"
	],
	"./main/report-notice/report-notice.module": [
		"./src/app/main/report-notice/report-notice.module.ts",
		"common",
		"main-report-notice-report-notice-module"
	],
	"./main/report-retailer/report-retailer.module": [
		"./src/app/main/report-retailer/report-retailer.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-report-retailer-report-retailer-module"
	],
	"./main/report-sms/report-sms.module": [
		"./src/app/main/report-sms/report-sms.module.ts",
		"common",
		"main-report-sms-report-sms-module"
	],
	"./main/report-target-achievement/report-target-achievement.module": [
		"./src/app/main/report-target-achievement/report-target-achievement.module.ts",
		"common",
		"main-report-target-achievement-report-target-achievement-module"
	],
	"./main/retailer-sales/retailer-sales.module": [
		"./src/app/main/retailer-sales/retailer-sales.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-retailer-sales-retailer-sales-module"
	],
	"./main/retailer-stock/retailer-stock.module": [
		"./src/app/main/retailer-stock/retailer-stock.module.ts",
		"common",
		"main-retailer-stock-retailer-stock-module"
	],
	"./main/retailer-to-dealer-campaign/retailer-to-dealer-campaign.module": [
		"./src/app/main/retailer-to-dealer-campaign/retailer-to-dealer-campaign.module.ts",
		"common",
		"main-retailer-to-dealer-campaign-retailer-to-dealer-campaign-module"
	],
	"./main/retailer-to-dealer-delivery/retailer-to-dealer-delivery.module": [
		"./src/app/main/retailer-to-dealer-delivery/retailer-to-dealer-delivery.module.ts",
		"common",
		"main-retailer-to-dealer-delivery-retailer-to-dealer-delivery-module"
	],
	"./main/retailer-to-dealer-invoice/retailer-to-dealer-invoice.module": [
		"./src/app/main/retailer-to-dealer-invoice/retailer-to-dealer-invoice.module.ts",
		"common",
		"main-retailer-to-dealer-invoice-retailer-to-dealer-invoice-module"
	],
	"./main/retailer-to-dealer-order/retailer-to-dealer-order.module": [
		"./src/app/main/retailer-to-dealer-order/retailer-to-dealer-order.module.ts",
		"common",
		"main-retailer-to-dealer-order-retailer-to-dealer-order-module"
	],
	"./main/route-plan-achievement/route-plan-achievement.module": [
		"./src/app/main/route-plan-achievement/route-plan-achievement.module.ts",
		"common",
		"main-route-plan-achievement-route-plan-achievement-module"
	],
	"./main/route-plan/route-plan.module": [
		"./src/app/main/route-plan/route-plan.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"main-pjp-pjp-module~main-route-plan-route-plan-module~main-user-wise-expense-summary-user-wise-expen~936cc80d",
		"common",
		"main-route-plan-route-plan-module"
	],
	"./main/safety-stock/safety-stock.module": [
		"./src/app/main/safety-stock/safety-stock.module.ts",
		"main-safety-stock-safety-stock-module"
	],
	"./main/sample-requisition/sample-requisition.module": [
		"./src/app/main/sample-requisition/sample-requisition.module.ts",
		"common",
		"main-sample-requisition-sample-requisition-module"
	],
	"./main/scheme/scheme.module": [
		"./src/app/main/scheme/scheme.module.ts",
		"common",
		"main-scheme-scheme-module"
	],
	"./main/secondary-order/secondary-order.module": [
		"./src/app/main/secondary-order/secondary-order.module.ts",
		"common",
		"main-secondary-order-secondary-order-module"
	],
	"./main/segment/segment.module": [
		"./src/app/main/segment/segment.module.ts",
		"main-segment-segment-module"
	],
	"./main/stock-survey/stock-survey.module": [
		"./src/app/main/stock-survey/stock-survey.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-stock-survey-stock-survey-module"
	],
	"./main/stock_distributor_centre/stock-distributor-centre.module": [
		"./src/app/main/stock_distributor_centre/stock-distributor-centre.module.ts",
		"main-stock_distributor_centre-stock-distributor-centre-module"
	],
	"./main/stock_transaction_distributor_centre/stock-transaction-distributor-centre.module": [
		"./src/app/main/stock_transaction_distributor_centre/stock-transaction-distributor-centre.module.ts",
		"main-stock_transaction_distributor_centre-stock-transaction-distributor-centre-module"
	],
	"./main/sub-segment/sub-segment.module": [
		"./src/app/main/sub-segment/sub-segment.module.ts",
		"common",
		"main-sub-segment-sub-segment-module"
	],
	"./main/ta-claim/ta-claim.module": [
		"./src/app/main/ta-claim/ta-claim.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~b2b65d01",
		"common",
		"main-ta-claim-ta-claim-module"
	],
	"./main/tag/tag.module": [
		"./src/app/main/tag/tag.module.ts",
		"main-tag-tag-module"
	],
	"./main/target-v4/target-v4.module": [
		"./src/app/main/target-v4/target-v4.module.ts",
		"main-asset-asset-module~main-bank-bank-module~main-target-v4-target-v4-module",
		"common",
		"main-target-v4-target-v4-module"
	],
	"./main/target/target.module": [
		"./src/app/main/target/target.module.ts",
		"common",
		"main-target-target-module"
	],
	"./main/tertiary-sales/tertiary-sales.module": [
		"./src/app/main/tertiary-sales/tertiary-sales.module.ts",
		"common",
		"main-tertiary-sales-tertiary-sales-module"
	],
	"./main/tour-allowance-claim/tour-allowance-claim.module": [
		"./src/app/main/tour-allowance-claim/tour-allowance-claim.module.ts",
		"main-tour-allowance-claim-tour-allowance-claim-module"
	],
	"./main/tour-plan/tour-plan.module": [
		"./src/app/main/tour-plan/tour-plan.module.ts",
		"common",
		"main-tour-plan-tour-plan-module"
	],
	"./main/tour-type/tour-type.module": [
		"./src/app/main/tour-type/tour-type.module.ts",
		"main-tour-type-tour-type-module"
	],
	"./main/training/training.module": [
		"./src/app/main/training/training.module.ts",
		"common",
		"main-training-training-module"
	],
	"./main/user-active-history/user-active-history.module": [
		"./src/app/main/user-active-history/user-active-history.module.ts",
		"main-user-active-history-user-active-history-module"
	],
	"./main/user-leave/user-leave.module": [
		"./src/app/main/user-leave/user-leave.module.ts",
		"common",
		"main-user-leave-user-leave-module"
	],
	"./main/user-role-wise-visit-target/user-role-wise-visit-target.module": [
		"./src/app/main/user-role-wise-visit-target/user-role-wise-visit-target.module.ts",
		"common",
		"main-user-role-wise-visit-target-user-role-wise-visit-target-module"
	],
	"./main/user-role/user-role.module": [
		"./src/app/main/user-role/user-role.module.ts",
		"common",
		"main-user-role-user-role-module"
	],
	"./main/user-wise-expense-summary/user-wise-expense-summary.module": [
		"./src/app/main/user-wise-expense-summary/user-wise-expense-summary.module.ts",
		"main-asset-asset-module~main-attendance-attendance-module~main-customer-customer-module~main-custome~70afe62e",
		"main-pjp-pjp-module~main-route-plan-route-plan-module~main-user-wise-expense-summary-user-wise-expen~936cc80d",
		"common",
		"main-user-wise-expense-summary-user-wise-expense-summary-module"
	],
	"./main/user/user.module": [
		"./src/app/main/user/user.module.ts",
		"common",
		"main-user-user-module"
	],
	"./main/visit-summary-approval-rules/visit-summary-approval.module": [
		"./src/app/main/visit-summary-approval-rules/visit-summary-approval.module.ts",
		"common",
		"main-visit-summary-approval-rules-visit-summary-approval-module"
	],
	"./main/visit/visit.module": [
		"./src/app/main/visit/visit.module.ts",
		"common",
		"main-visit-visit-module"
	],
	"./main/weekend/weekend.module": [
		"./src/app/main/weekend/weekend.module.ts",
		"common",
		"main-weekend-weekend-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;